<div class="padding">
	<b>{{ data.title }}</b>

	@if (dateRange) {
		<div class="flex center margin-top">
			<div class="flex column">
				<div class="padding-small bg-grey margin-bottom-smallest">From</div>
				<div class="padding-small bg-grey margin-bottom-smallest">To</div>
			</div>
			<div class="flex column flex-1">
				<mat-form-field appearance="outline" class="margin-bottom-small full-width">
					<input matInput [matDatepicker]="picker5" [(ngModel)]="dateRange.from" [max]="dateRange.to" />
					<mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
					<mat-datepicker #picker5></mat-datepicker>
				</mat-form-field>

				<mat-form-field appearance="outline" class="margin-bottom-small full-width">
					<input matInput [matDatepicker]="picker4" [(ngModel)]="dateRange.to" [min]="dateRange.from" />
					<mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
					<mat-datepicker #picker4></mat-datepicker>
				</mat-form-field>
			</div>
		</div>

		<div class="flex column end margin-top-small">
			<div class="flex center">
				<button class="stroked margin-right-smallest" (click)="back()">
					<i class="fa-solid fa-rotate-left margin-right-small"></i>
					Discard
				</button>
				<button color="accent" (click)="apply()" [disabled]="(!dateRange.to && dateRange.from) || (!dateRange.from && dateRange.to)" cdkFocusInitial>
					<i class="fa-solid fa-check margin-right-small"></i>
					Apply
				</button>
			</div>
		</div>
	}
</div>
